import { ComponentType } from 'react'
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap'
import styled from 'styled-components'

const Menu = styled(DropdownMenu)`
  padding: 0;
`

interface Props {
  label: string
  disabled?: boolean
  isOpen: boolean
  isActive: boolean
  onToggle: () => void
}

export const FilterDesktop: ComponentType<Props> = ({ label, disabled, isOpen, isActive, onToggle, children }) => {
  return (
    <Dropdown isOpen={isOpen} toggle={onToggle}>
      <DropdownToggle
        className="text-nowrap"
        color={isActive ? 'primary' : 'dimmed'}
        active={isOpen}
        outline={!isActive}
        disabled={disabled}
      >
        {label}
      </DropdownToggle>
      <Menu>{children}</Menu>
    </Dropdown>
  )
}
